export const BITBUCKET = 'BITBUCKET';
export const BITBUCKET_SERVER = 'BITBUCKET_SERVER';
export const GITHUB_ENTERPRISE = 'GITHUB_ENTERPRISE';
export const GITHUB = 'GITHUB';
export const AZURE_DEV_OPS = 'AZURE_DEVOPS';
export const GITLAB = 'GITLAB';
